import { render, staticRenderFns } from "./AppComponent.vue?vue&type=template&id=3c6864d1&"
import script from "./AppComponent.vue?vue&type=script&lang=js&"
export * from "./AppComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports